import { motion } from "framer-motion";
import { Rocket, Building2, CheckCircle } from "lucide-react";

const audiences = [
  {
    icon: Rocket,
    title: "Startups",
    text: "AI and digital solutions for early-to-growth-stage companies — MVP-to-scale tooling, automation, and AI-native workflows that give you an unfair advantage from day one.",
    examples: "SaaS, fintech, healthtech, edtech, D2C, deeptech",
  },
  {
    icon: Building2,
    title: "Mid-Market Enterprises",
    text: "Custom AI/Digital solutions for businesses ready to scale — from demand forecasting and supply chain optimization to intelligent monitoring and decision intelligence platforms.",
    examples: "Pharma, FMCG, logistics, telecom, government, infrastructure",
  },
];

const differentiators = [
  "You pay for outcomes, not effort hours",
  "We work in Tier 2 & 3 cities, not just metros",
  "We use your existing infrastructure — no rip-and-replace",
  "Results within 90 days, not 2-year roadmaps",
  "20+ years real-world experience across Shell, BT, Telstra, Tata",
  "Delivery from Patna & Bengaluru — local presence, global expertise",
];

export default function Vision() {
  return (
    <section id="vision" data-testid="vision-section" className="py-24 md:py-32 relative bg-[#faf7f2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="text-xs font-bold uppercase tracking-[0.2em] text-[#2a9d8f] mb-4">Who This Is For</motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2d2926] mb-16" style={{ fontFamily: 'Fraunces, serif' }}>
          Built for Teams That <span className="gradient-text">Build Things</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {audiences.map((a, i) => (
            <motion.div key={a.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              className="warm-card p-7" data-testid={`vision-card-${i}`}>
              <a.icon className="text-[#2a9d8f] w-8 h-8 mb-5" strokeWidth={1.5} />
              <h3 className="text-xl font-semibold text-[#2d2926] mb-2" style={{ fontFamily: 'Fraunces, serif' }}>{a.title}</h3>
              <p className="text-sm text-[#5c564e] leading-relaxed mb-4">{a.text}</p>
              <div className="pt-3 border-t border-[#ebe5dc]">
                <p className="text-[10px] text-[#8a8078] uppercase tracking-wider mb-1">Industries</p>
                <p className="text-xs text-[#5c564e]">{a.examples}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="warm-card p-8">
          <h3 className="text-lg font-semibold text-[#2d2926] mb-5" style={{ fontFamily: 'Fraunces, serif' }}>Why Companies Choose Us Over Big 4 Consultants</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {differentiators.map((d) => (
              <div key={d} className="flex items-start gap-2.5">
                <CheckCircle className="w-4 h-4 text-[#2a9d8f] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-[#3d3832]">{d}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
